import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';

type ThisApi = ApiDefinition['/products/{productId}/availability-blocks']['PUT'];
type Input = ThisApi['params'] & ThisApi['query'] & ThisApi['body'] & { debugKey: string };

const getAvailabilityBlocks = async ({
  blockData,
  canBookWithConflicts,
  debugKey,
  productId,
  year,
  teamMemberPersonId,
  timezone,
  month,
}: Input): Promise<ThisApi['response']> => {
  const response = await noodleApiClient.put(
    `/products/${productId}/availability-blocks`,
    { blockData },
    {
      params: {
        canBookWithConflicts,
        month,
        requestKey: debugKey,
        teamMemberPersonId,
        timezone,
        year,
      },
    },
  );
  return response.data;
};

export default getAvailabilityBlocks;
